export enum paymentType {
	'MASTER_NUMBER',
	'CREDIT_CARD',
}

export enum serviceType {
	'TOP_UP' = 'TOP_UP',
	'ADD_ONS' = 'ADD_ONS',
	'SERVICES' = 'SERVICES',
}

export enum recurrenceType {
	'ONE_TIME',
}

export enum subscriptionStatus {
	ACTIVE = 'A',
	EXPIRED = 'E',
}

export type SingleSubscription = {
	id: number;
	numbersCount: number;
	endDate: string;
	oneTimeAmount: number;
	paymentType: paymentType;
	recurrence: string;
	startDate: string;
	status: string;
	target: string;
	totalAmount: number;
	type: serviceType;
	createdBy: number;
};

const model: types.models.InputModel = {
	id: 'id',
	numbersCount: 'numbersCount',
	endDate: 'endDate',
	oneTimeAmount: 'oneTimeAmount',
	paymentType: 'paymentType',
	recurrence: 'recurrence',
	startDate: 'startDate',
	status: 'status',
	target: 'target',
	totalAmount: 'totalAmount',
	type: 'type',
	createdBy: 'createdBy',
};

export default model;
